<span class="message-control-label label-visible">

  @if (selectedLabels.length > 1) {
    <div >
      @for (label of selectedLabels; track label) {
        <span class="oneline d-block">
          ∙ {{label}}
        </span>
      }
    </div>
  }
  @if (selectedLabels.length == 1) {
    <div>
      <span>{{selectedLabels[0]}}</span>
    </div>
  }

  @if (selectedLabels.length == 0) {
    <div>
      <span>Nichts ausgewählt.</span>
    </div>
  }

</span>